import { render, staticRenderFns } from "./TestProcessForm.vue?vue&type=template&id=49d55096"
import script from "./TestProcessForm.vue?vue&type=script&lang=js"
export * from "./TestProcessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports